<p class="error">
  <slot />
</p>

<style>
  .error {
    color: #ea3009;
  }
</style>
